import { pathOr } from 'ramda';
import { IPromo } from '../../types/newbuilding/promos';
import { IApplicationState } from '../../types/redux';

export function getPromos(state: IApplicationState): IPromo[] {
  return pathOr([], ['newbuilding', 'promoInfos'], state);
}
